import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  className?: string;
  id?: string;
  'data-testid'?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  className = '',
  id = 'empty-state-container',
  'data-testid': dataTestId = 'empty-state',
  showBackButton = false,
  onBackClick
}) => {
  return (
    <div 
      id={id}
      data-testid={dataTestId}
      className={`min-h-screen bg-gradient-to-br from-slate-50 via-white to-purple-50 flex items-center justify-center ${className}`}
    >
      <Card className="bg-white shadow-lg border-0 rounded-2xl max-w-2xl w-full mx-4">
        <CardContent className="p-12">
          <div className="flex flex-col items-center justify-center text-center space-y-6">
            {icon && (
              <div 
                className="flex items-center justify-center"
                data-testid="empty-state-icon"
              >
                {icon}
              </div>
            )}
            
            <div className="space-y-4">
              <h1 
                id="empty-state-title"
                data-testid="empty-state-title"
                className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight"
              >
                {title}
              </h1>
              
              <p 
                id="empty-state-description"
                data-testid="empty-state-description"
                className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-lg mx-auto"
              >
                {description}
              </p>
            </div>
            
            {showBackButton && onBackClick && (
              <div className="mt-8">
                <button
                  id="empty-state-back-button"
                  data-testid="empty-state-back-button"
                  onClick={onBackClick}
                  className="bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white px-8 py-3 rounded-lg font-medium flex items-center space-x-2"
                >
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  <span>Back</span>
                </button>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmptyState;